<template lang="pug">
    .validating-button__groups
        LocalButton.validating-button__groups-btn(
            v-for="(btn, idx) in buttons"
            :data="btn"
            :key="btn.id"
            @click="goToChoosen"
        )
        Button.validating-button__groups-valid__btn( ) Добавить
</template>
<script>
import LocalButton from './Button';

export default {
  components: {
    LocalButton
  },
  data() {
    return {
      buttons: [
        {
          name: 'Статистика',
          id: 1
        },
        {
          name: 'Лента ответов',
          id: 2
        },
        {
          name: 'Скрипты  проверки',
          id: 3
        }
      ]
    };
  }
  // methods: {
  //     goToChoosen(id){
  //     }
  // }
};
</script>
